module.exports = __webpack_public_path__ + "static/media/ic-calendar.2073ad73.svg";